module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "wrapper-padding-bottom"
  }, [_c('problems-planet'), _vm._v(" "), _c('problems-ocean'), _vm._v(" "), _c('problems-plastickill'), _vm._v(" "), _c('problems-graph')], 1), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-80a9dfc6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Problems.vue
// module id = 167
// module chunks = 1